const $state = document.querySelector('#global-state');

export default function getState(key) {
  if ($state.dataset.hasOwnProperty(key)) {
    return $state.dataset[key];
  }
  return null;
}
